import * as React from 'react';

function SvgPaymentOthers(props) {
  return (
    <svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width={56} height={56} rx={4} fill="#F5F5F5" />
      <path
        d="M37.625 17.938h-8.313a.439.439 0 00-.437.437v8.313c0 .24.197.437.438.437h8.312c.24 0 .438-.197.438-.438v-8.312a.439.439 0 00-.438-.438zm0 10.937h-8.313a.439.439 0 00-.437.438v8.312c0 .24.197.438.438.438h8.312c.24 0 .438-.197.438-.438v-8.313a.439.439 0 00-.438-.437zM26.687 17.937h-8.312a.439.439 0 00-.438.438v8.313c0 .24.197.437.438.437h8.313c.24 0 .437-.197.437-.438v-8.312a.439.439 0 00-.438-.438zm0 10.938h-8.312a.439.439 0 00-.438.438v8.312c0 .24.197.438.438.438h8.313c.24 0 .437-.197.437-.438v-8.313a.439.439 0 00-.438-.437z"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default SvgPaymentOthers;
